import { useGetNavigationMenu } from "../../Shared/Navigation/navigationMenu/useGetNavigationMenu";
import { useAdminMenuPriviligesProviderContext } from "../../Shared/Navigation/priviligesProviders/AdminMenuPriviligesProvider";
import { useWorkerMenuPriviligesProviderContext } from "../../Shared/Navigation/priviligesProviders/WorkerMenuPriviligesProvider";
import { useWorkplaceMenuPriviligesProviderContext } from "../../Shared/Navigation/priviligesProviders/WorkplaceMenuPriviligesProvider";
import {
  NavigationItem as NavigationItemParams,
  NavigationSection as NavigationSectionParams,
} from "../../Shared/Navigation/navigationMenu/types";
import { NavigationMenuItemDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/MenuItem";
import { NavigationMenuSectionTitleDesktop } from "@src/appV2/redesign/AppLayout/Desktop/Navigation/MenuSectionTitle";

export interface NavigationMenuItemsDesktopProps {
  isAdmin: boolean;
  isWorkplace: boolean;
  isWorker: boolean;
}

function NavigationItem(params: NavigationItemParams) {
  const { label, iconType, isSelected, routeTo, onClick } = params;

  return (
    <NavigationMenuItemDesktop
      iconType={iconType}
      isSelected={isSelected}
      routeTo={routeTo}
      onClick={onClick}
    >
      {label}
    </NavigationMenuItemDesktop>
  );
}

function NavigationSection(params: NavigationSectionParams) {
  const { label, items } = params;

  return (
    <>
      <NavigationMenuSectionTitleDesktop>{label}</NavigationMenuSectionTitleDesktop>
      {items.map((item) => (
        <NavigationItem key={item.label} {...item} />
      ))}
    </>
  );
}

export function NavigationMenuItemsDesktop(props: NavigationMenuItemsDesktopProps) {
  const { isAdmin, isWorker, isWorkplace } = props;

  const currentPath = location.pathname;
  const adminMenuPriviliges = useAdminMenuPriviligesProviderContext();
  const workplaceMenuPriviliges = useWorkplaceMenuPriviligesProviderContext();
  const workerMenuPriviliges = useWorkerMenuPriviligesProviderContext();

  const navigationMenu = useGetNavigationMenu(
    isAdmin,
    adminMenuPriviliges,
    isWorker,
    workerMenuPriviliges,
    isWorkplace,
    workplaceMenuPriviliges,
    currentPath
  );

  return (
    <>
      {navigationMenu.items.map((item) =>
        "items" in item ? (
          <NavigationSection key={item.label} {...item} />
        ) : (
          <NavigationItem key={item.label} {...item} />
        )
      )}
    </>
  );
}
